<template>
  <button type="button" class="catalog-save-filter" @click="$emit('saveFilter')">
    <svg class="catalog-save-filter__icon">
      <use xlink:href="#svg-plus"></use>
    </svg>
    {{ messages.doSaveFilters }}
  </button>
</template>

<script lang="ts" setup>
import { IMessages } from '@/interfaces/IMessages';

const props = defineProps<{ messages: IMessages }>();
</script>

<style lang="scss" scoped>
.catalog-save-filter {
  display: flex;
  align-items: center;
  color: var(--color-golden-browm);
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-transform: uppercase;
  &__icon {
    width: 18px;
    height: 18px;
    margin-right: 8px;
    fill: currentColor;
  }
}
</style>
